'use client';

import { c as _c } from "react/compiler-runtime";
import { RenderBoundary, SimulatedTradeStage as SharedStage, type SimulatedTradeStageProps, type StageAssets } from '@morfi/how-morfi-works';
import you from '@morfi/how-morfi-works/assets/avatar-men-32.jpg';
import dan from '@morfi/how-morfi-works/assets/avatar-men-75.jpg';
import priya from '@morfi/how-morfi-works/assets/avatar-women-44.jpg';
import maya from '@morfi/how-morfi-works/assets/avatar-women-65.jpg';
import cover from '@morfi/how-morfi-works/assets/market-cover.jpg';
import no from '@morfi/how-morfi-works/assets/outcome-no.jpg';
import yes from '@morfi/how-morfi-works/assets/outcome-yes.jpg';
import { usdToD6 } from '@morfi/how-morfi-works/engine';
import { useTranslations } from 'next-intl';
import { useFormattedCurrency } from '@/lib/currency';
import { sendLog } from '@/lib/telemetry';
import '@morfi/how-morfi-works/styles.css';
export type { StageControl } from '@morfi/how-morfi-works';
const assets: StageAssets = {
  avatars: {
    you: you.src,
    dan: dan.src,
    priya: priya.src,
    maya: maya.src
  },
  outcomes: {
    yes: yes.src,
    no: no.src
  },
  cover: cover.src
};

/** The web host owns translations, selected currency and navigation. */
export function SimulatedTradeStage(props) {
  const $ = _c(8);
  const t = useTranslations("simulated_trade");
  const {
    formatD6
  } = useFormattedCurrency();
  let t0;
  if ($[0] !== formatD6) {
    t0 = {
      money: usd => formatD6(usdToD6(usd), "whole"),
      compact: usd_0 => formatD6(usdToD6(usd_0), "compactTight")
    };
    $[0] = formatD6;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t || $[3] !== t0) {
    t1 = {
      t,
      assets,
      format: t0
    };
    $[2] = t;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <RenderBoundary onFailure={_temp}><SharedStage {...props} presentation={t1} /></RenderBoundary>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(category) {
  sendLog("how_morfi_works.render_failed", "error", {
    category
  });
}